import { State, Action, StateContext, Selector } from '@ngxs/store';
import { User } from '../models/user.model';
import { StoreUser , DestroyUser} from '../actions/user.action';

export class UserStateModel {
  user: User;
}

@State<UserStateModel>({
  name: 'user',
  defaults: {
    user: null,
  },
})

export class UserState {

    @Selector()
    static getUser(state: UserStateModel) {
      return state.user;
    }

    @Action(StoreUser)
    store({patchState}: StateContext<UserStateModel>,
      {payload}: StoreUser) {
        patchState({
          user: payload,
        });
    }

    @Action(DestroyUser)
    destroy({patchState}: StateContext<UserStateModel>) {
        patchState({
          user: null,
        });
    }


}
